import { detect } from "detect-browser";

const br = detect();
const browser = {
  name: br?.name ?? "",
  version: br?.version ?? "",
  os: br?.os ?? "",
};

export default browser;